/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { dashboardContentVariantSelector } from '../../scenes/Organisation/OrganisationSelectors';
import { getPlanFlowNav } from '../../scenes/Dashboard/scenes/Plan/planSections';
import ProcessBar from './ProcessBar';

/**
 * ProcessBar with prev/next derived from partner-specific plan section order.
 * Explicit prev/next props override auto-resolved flow navigation (e.g. Strategic BIA step handlers).
 */
function PlanProcessBar({ location, dashboardContentVariant, prev, next, ...rest }) {
  const flowNav = getPlanFlowNav(location.pathname, dashboardContentVariant);

  return (
    <ProcessBar
      prev={prev !== undefined ? prev : flowNav.prev}
      next={next !== undefined ? next : flowNav.next}
      {...rest}
    />
  );
}

PlanProcessBar.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired,
  dashboardContentVariant: PropTypes.string.isRequired,
  prev: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  next: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const mapStateToProps = (state) => ({
  dashboardContentVariant: dashboardContentVariantSelector(state),
});

export default withRouter(connect(mapStateToProps)(PlanProcessBar));
